import { render, staticRenderFns } from "./ChannelMetric.vue?vue&type=template&id=39e76f92&scoped=true"
import script from "./ChannelMetric.vue?vue&type=script&lang=js"
export * from "./ChannelMetric.vue?vue&type=script&lang=js"
import style0 from "./ChannelMetric.vue?vue&type=style&index=0&id=39e76f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e76f92",
  null
  
)

export default component.exports